import React from 'react'
import { Col, Switch } from 'antd'
import styled from 'styled-components'
import { TableRow } from 'Components/Shared/Table'
import { ConfigVendorERCListDetail } from 'features/admin/setting-vendor-erc/types'

type Props = {
  onClick?: (evt: any, item: any) => void
  item: ConfigVendorERCListDetail
  selected?: boolean
}

const RowItem: React.FC<Props> = props => {
  const { item, selected } = props
  const onClick = (evt: any) => {
    if (props.onClick) {
      props.onClick(evt, item)
    }
  }

  return (
    <RowModel>
      <TableRow
        minHeight={70}
        spaceBetweenRow={8}
        paddingLeft={24}
        selected={selected}
      >
        <Col span={5}>
          <TxtReg>{item.VendorCode}</TxtReg>
        </Col>

        <Col span={15}>
          <TxtReg>{item.VendorName}</TxtReg>
        </Col>

        <Col span={2}>
          <SwitchArea>
            <Switch
              checked={item.IsActive == 'A'}
              onChange={() => {
                onClick(item.IsActive === 'A' ? 'N' : 'A')
              }}
              disabled={false}
            />
          </SwitchArea>
        </Col>
      </TableRow>
    </RowModel>
  )
}

const RowModel = styled.div`
  .ant-row {
    cursor: auto;
  }
`
const SwitchArea = styled.div`
  padding: 0 30px;
  float: left;
`

const Score: any = styled.div`
  font-size: 20px;
  font-family: 'DB Helvethaica X 75 Bd';
  text-decoration: underline;
  cursor: pointer;
`

const PassScore = styled(Score)`
  color: #63cea6;
`

const FailScore = styled(Score)`
  color: #d0494c;
`

const Bold: any = styled.div`
  font-family: 'DB Helvethaica X 75 Bd';
  color: #000;
  font-size: 20px;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  padding-right: 5px;
`

const TxtReg = styled(Bold)`
  font-family: 'DB Helvethaica X 55 Regular';
`

const Icon = styled.div`
  float: left;
  margin-right: 20px;
  margin-top: 5px;
  cursor: pointer;
`
const Status = styled.div`
  height: 20px;
  border-radius: 10px;
  color: white;
  text-align: center !important;
  font-size: 16px;
  padding: 5px 15px;
  font-size: 16px;
  align-items: center;
  display: inline-flex;
`

export default RowItem
